<template>
  <div class="index py-5">
    <div class="form-container">
      <AveineUserList :APIbaseURL="APIbaseURL"/>
    </div>
  </div>
</template>

<script>
import { AveineUserList }  from 'aveine-user'
export default {
  name: 'Index',
    data () {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  components: {
    AveineUserList
  }
}
</script>
